import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Button,
  styled,
  Typography,
  Collapse,
  List,
} from "@mui/material";
import DownloadIcon from "assets/icons/DownloadIcon";
import ExpandLessIcon from "assets/icons/ExpandLessIcon";
import ExpandMoreIcon from "assets/icons/ExpandMoreIcon";
import { useState } from "react";
import shortid from "shortid";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import uploadedImg from "assets/images/uploaded.png";
import warningImg from "assets/images/warning.png";

const xlsx = require("xlsx");

const errorItems = [
  {
    shortTitle: "نام کالا",
    longTitle: "نام کالا نامعتبر است",
    description: "نام کالا/خدمات نمیتواند خالی باشد",
  },
  {
    shortTitle: "نام کالا",
    longTitle: "نام کالا نامعتبر است",
    description: "نام کالا/خدمات نمیتواند خالی باشد",
  },
  {
    shortTitle: "نام کالا",
    longTitle: "نام کالا نامعتبر است",
    description: "نام کالا/خدمات نمیتواند خالی باشد",
  },
  {
    shortTitle: "نام کالا",
    longTitle: "نام کالا نامعتبر است",
    description: "نام کالا/خدمات نمیتواند خالی باشد",
  },
  {
    shortTitle: "نام کالا",
    longTitle: "نام کالا نامعتبر است",
    description: "نام کالا/خدمات نمیتواند خالی باشد",
  },
  {
    shortTitle: "نام کالا",
    longTitle: "نام کالا نامعتبر است",
    description: "نام کالا/خدمات نمیتواند خالی باشد",
  },
  {
    shortTitle: "نام کالا",
    longTitle: "نام کالا نامعتبر است",
    description: "نام کالا/خدمات نمیتواند خالی باشد",
  },
];

const SubItem = styled("div")(({ theme }) => ({
  display: "flex",
  height: "56px",
  cursor: "pointer",
  backgroundColor: "#FFFCFD",
  border: "1px solid #A20000",
  width: "80%",
  marginTop: "20px",
  borderRadius: theme.shape.borderRadius,
  padding: "12px 12px",
  position: "relative",
}));

const ErrorDetails = styled("div")(({ theme }) => ({
  height: "88px",
  boxShadow: "0px 2px 14px rgba(16, 98, 208, 0.09)",
  width: "100%",
  zIndex: 3,
  right: 0,
  backgroundColor: "white",
  display: "grid",
  gridTemplateRows: "45% 55%",
  borderRadius: "4px",
  position: "absolute",
  top: "56px",
}));

const EnterInfoComponentContainer = styled("div")(({ theme }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
  flexDirection: "column",
}));
const UploadContainer = styled("div")(({ theme }) => ({
  width: "50%",
  height: "250px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
}));
const UploadAvatar = styled("img")(({ theme }) => ({
  height: "130px",
  width: "140px",
}));
const WarningAvatar = styled(Avatar)(({ theme }) => ({
  height: "35px",
  width: "38px",
  padding: "8px",
  // borderRadius: '50%',
  backgroundColor: "#ffeaf0",
}));

interface CollapseDependent {
  isOpen: boolean;
}

const ProblemContainer = styled("div")<CollapseDependent>(({ theme, isOpen }) => ({
  width: "50%",
  position: isOpen ? "absolute" : "inherit",
  top: isOpen ? "70px" : "inherit",
  backgroundColor: "white",
  height: "100px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const StyledListItemText = styled(ListItemText)({
  textAlign: "right",
  marginTop: "10px",
});
const SubListItemText = styled(ListItemText)({
  paddingRight: "15px",
});
const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: "30px",
  marginLeft: "10px",
});
const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderBottom: `solid 2px ${theme?.palette.disabled.light}`,
  padding: "12px 24px",
  maxHeight: "70px",
  borderRadius: "4px",
  backgroundColor: "#F8F7FA",
}));
const ErrorDetailUpperItem = styled("div")(({ theme }) => ({
  display: "flex",
  borderBottom: `solid 2px ${theme.palette.disabled.light}`,
  alignItems: "center",
  height: "100%",
  padding: "0 8px",
}));
const ErrorDetailLowerItem = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  padding: "0 8px",
}));

const DangerDot = styled("div")(({ theme }) => ({
  backgroundColor: "#A20000",
  width: "13px",
  marginLeft: "12px",
  height: "13px",
  borderRadius: "50%",
}));

const DownloadContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
}));

const EnterInfoComponent = () => {
  //@ts-ignore
  const excelReducer = useSelector((state) => state).excelReducer;
  //@ts-ignore
  const savedItems = excelReducer.savedItems;

  //@ts-ignore
  const formikContext = useFormikContext();

  //@ts-ignore
  const activeTab = formikContext.values[formikContext.values["colSelected"]];

  const [openErrors, setOpenErrors] = useState(false);
  const handleOpenErrors = () => {
    setOpenErrors((previousValue) => !previousValue);
  };

  const [errorHover, setErrorHovered] = useState(Array(errorItems.length).fill(false));
  const handleErrorHoverEnter = (index: number) => {
    errorHover[index] = true;
    setErrorHovered([...errorHover]);
  };
  const handleErrorHoverLeave = () => {
    const newErrorHover = Array(errorItems.length).fill(false);
    setErrorHovered(newErrorHover);
  };

  const errorsExcelDownload = () => {
    //@ts-ignore
    const errorItems = savedItems.filter((item) => item.status === "error");

    //@ts-ignore
    const items = [];

    for (const item of errorItems) {
      let excelItem = {
        ...item,
        ...item.main,
        ...item.others,
      };

      items.push(excelItem);
    }

    const worksheet = xlsx.utils.json_to_sheet(items);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, activeTab.table);
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    xlsx.writeFile(workbook, `${activeTab.table.charAt(0).toUpperCase() + activeTab.table.slice(1)}.xlsx`);
  };

  return (
    <EnterInfoComponentContainer>
      <UploadContainer>
        <UploadAvatar src={uploadedImg} />
        <Typography variant="h5">
          {
            //@ts-ignore
            savedItems.filter((item) => item.status === "saved").length + " " + activeTab.modelName
          }
        </Typography>
        <Typography color="#6B7888">با موفقیت ثبت شدند</Typography>
      </UploadContainer>
      <ProblemContainer isOpen={openErrors}>
        <StyledListItemButton
          disableRipple
          // onClick={handleOpenErrors}
          // active={open[index]} onClick={() => handleOpen(index)}
        >
          <StyledListItemIcon>
            <WarningAvatar src={warningImg} />
          </StyledListItemIcon>
          <StyledListItemText>
            <Typography
              variant="body1"
              // color={open[index] ? theme.palette.text.primary : theme.palette.text.secondary}
            >
              {
                //@ts-ignore
                "ثبت " +
                  savedItems.filter((item: any) => item.status === "error").length +
                  " " +
                  activeTab.modelName +
                  " با خطا مواجه شد"
              }
            </Typography>
          </StyledListItemText>
          {/*<Typography color='primary'>*/}
          {/*    مشاهده*/}
          {/*</Typography>*/}
          {/*{openErrors ? <ExpandLessIcon /> : <ExpandMoreIcon />}*/}
        </StyledListItemButton>
        {/*<Collapse in={openErrors} sx={{ backgroundColor: 'white' }} timeout="auto" unmountOnExit>*/}
        {/*    <List sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }} component="div" disablePadding>*/}
        {/*        {*/}
        {/*            //@ts-ignore*/}
        {/*            savedItems.filter(item => item.status === 'error').map((error, key) => (<SubItem onMouseEnter={() => handleErrorHoverEnter(key)} onMouseLeave={handleErrorHoverLeave} key={shortid.generate()}>*/}
        {/*            <StyledListItemIcon>*/}
        {/*                <WarningAvatar src='/assets/images/icons/warning.png' />*/}
        {/*            </StyledListItemIcon>*/}
        {/*            <SubListItemText>*/}
        {/*                <Typography variant='body2'*/}
        {/*                >*/}
        {/*                    {'error'}*/}
        {/*                </Typography>*/}
        {/*            </SubListItemText>*/}
        {/*            {errorHover[key] && <ErrorDetails>*/}
        {/*                <ErrorDetailUpperItem>*/}
        {/*                <DangerDot/>*/}
        {/*                <Typography color="#515151" variant='body2'>*/}
        {/*                        {'error.error'}*/}
        {/*                    </Typography>*/}
        {/*                </ErrorDetailUpperItem>*/}
        {/*                <ErrorDetailLowerItem>*/}
        {/*                    <Typography variant='body2'>*/}
        {/*                        {error.error}*/}
        {/*                    </Typography>*/}
        {/*                </ErrorDetailLowerItem>*/}
        {/*            </ErrorDetails>}*/}
        {/*        </SubItem>)*/}
        {/*        )}*/}
        {/*    </List>*/}
        {/*</Collapse>*/}
        <DownloadContainer>
          <DownloadIcon primary={true} />
          <Typography variant="body2" color="primary" onClick={() => errorsExcelDownload()}>
            &nbsp; دانلود محصولات مشکل دار به صورت .xlsx
          </Typography>
        </DownloadContainer>
      </ProblemContainer>
    </EnterInfoComponentContainer>
  );
};

export default EnterInfoComponent;

const ActionContainer = styled("div")(({ theme }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const EnterInfoAction = ({ onSubmit, onIgnore }: { onSubmit: () => void; onIgnore: () => void }) => {
  return (
    <ActionContainer>
      {/* @ts-ignore */}
      <Button
        onClick={onIgnore}
        disableRipple
        disableElevation
        disableFocusRipple
        sx={{ width: "208px" }}
        variant="contained"
      >
        بستن
      </Button>
    </ActionContainer>
  );
};
